import React from 'react'

const Classes = () => {
  return (
    <section className='lg:px-20 px-5 max-sm:px-0 max-md:mb-5' id='classesNav'> 
      <h1 className='lg:text-4xl md:text-3xl text-2xl text-center text-brown-700 font-bold font-heading'>Classes & Workshops</h1>
      <div className='flex md:flex-row flex-col justify-center items-center w-full'>
        <div className='lg:w-[30%] md:w-[55%] w-[75%] lg:m-10 md:m-5 mx-auto my-8 bg-beige/60 rounded-lg shadow-lg'>
          <div>
            <img className='rounded-t-lg aspect-[3/2]' src='/images/class/bas-relief.jpg' />
          </div>
          <div className='w-full flex flex-col items-center my-4'>
            <h1 className='mb-4 text-center lg:text-3xl md:text-2xl text-xl font-semibold text-brown-700 font-heading'>Bas-Relief Workshop</h1>
            <button className='text-brown-700 lg:text-2xl md:text-xl text-base font-semibold shadow-inset lg:max-w-[250px] w-[85%] transition-all rounded-lg py-2 hover:shadow-xl bg-beige/70 hover:bg-beige font-para'><a href='/classes/3' target='_blank' className='m-0 px-8 py-1'>More Details!</a></button>
          </div>
        </div>
        <div className='lg:w-[30%] md:w-[55%] w-[75%] lg:m-10 md:m-5 mx-auto bg-beige/60 rounded-lg shadow-lg'>
          <div>
            <img className='rounded-t-lg aspect-[3/2]' src='/images/class/ganeshidol.jpg' />
          </div>
          <div className='w-full flex flex-col items-center my-4'>
            <h1 className='mb-4 text-center lg:text-3xl md:text-2xl text-xl font-semibold text-brown-700 font-heading'>Ganesha Idol Workshop</h1>
            <button className='text-brown-700 lg:text-2xl md:text-xl text-base font-semibold shadow-inset lg:max-w-[250px] w-[85%] transition-all rounded-lg py-2 hover:shadow-xl bg-beige/70 hover:bg-beige font-para'><a href='/classes/4' target='_blank' className='m-0 px-8 py-1'>More Details!</a></button>
          </div>
        </div>
      </div>
      <div className='flex md:flex-row flex-col justify-center items-center w-full'>
        <div className='lg:w-[30%] md:w-[55%] w-[75%] lg:m-10 md:m-5 mx-auto my-8 bg-beige/60 rounded-lg shadow-lg'>
          <div>
            <img className='rounded-t-lg aspect-[3/2]' src='/images/class/class1.jpg' />
          </div>
          <div className='w-full flex flex-col items-center my-4'>
            <h1 className='mb-4 text-center lg:text-3xl md:text-2xl text-xl font-semibold text-brown-700 font-heading'>Indian Traditional Art</h1>
            <button className='text-brown-700 lg:text-2xl md:text-xl text-base font-semibold shadow-inset lg:max-w-[250px] w-[85%] transition-all rounded-lg py-2 hover:shadow-xl bg-beige/70 hover:bg-beige font-para'><a href='/classes/1' target='_blank' className='m-0 px-8 py-1'>More Details!</a></button>
          </div>
        </div>
        <div className='lg:w-[30%] md:w-[55%] w-[75%] lg:m-10 md:m-5 mx-auto bg-beige/60 rounded-lg shadow-lg'>
          <div>
            <img className='rounded-t-lg aspect-[3/2]' src='/images/class/class2.jpg' />
          </div>
          <div className='w-full flex flex-col items-center my-4'>
            <h1 className='mb-4 text-center lg:text-3xl md:text-2xl text-xl font-semibold text-brown-700 font-heading'>Request a Class</h1>
            <button className='text-brown-700 lg:text-2xl md:text-xl text-base font-semibold shadow-inset lg:max-w-[250px] w-[85%] transition-all rounded-lg py-2 hover:shadow-xl bg-beige/70 hover:bg-beige font-para'><a href='/classes/2' target='_blank' className='m-0 px-8 py-1'>More Details!</a></button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Classes